var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSteps1({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 684,
    height: 427,
    viewBox: "0 0 684 427",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_413_3)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 89.5234,
    y: 399.939,
    width: 7,
    height: 1.5,
    transform: "rotate(-14.1424 89.5234 399.939)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104.064,
    y: 395.77,
    width: 10,
    height: 1.5,
    transform: "rotate(-19.7043 104.064 395.77)",
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 123.572,
    y: 388.527,
    width: 10,
    height: 1.5,
    transform: "rotate(-22.446 123.572 388.527)",
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 142.881,
    y: 380.238,
    width: 10,
    height: 1.5,
    transform: "rotate(-25.8198 142.881 380.238)",
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 161.115,
    y: 371.021,
    width: 10,
    height: 1.5,
    transform: "rotate(-30.4557 161.115 371.021)",
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 178.879,
    y: 359.92,
    width: 10,
    height: 1.5,
    transform: "rotate(-37.9958 178.879 359.92)",
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 194.963,
    y: 346.055,
    width: 10,
    height: 1.5,
    transform: "rotate(-46.3278 194.963 346.055)",
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 208.877,
    y: 330.566,
    width: 10,
    height: 1.5,
    transform: "rotate(-53.4815 208.877 330.566)",
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 220.703,
    y: 313.369,
    width: 10,
    height: 1.5,
    transform: "rotate(-60.9867 220.703 313.369)",
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 230.213,
    y: 294.975,
    width: 7.86767,
    height: 1.5,
    transform: "rotate(-66.6204 230.213 294.975)",
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 238.969,
    y: 273.559,
    width: 7.80361,
    height: 1.5,
    transform: "rotate(-69.4427 238.969 273.559)",
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 245.291,
    y: 256.41,
    width: 10,
    height: 1.5,
    transform: "rotate(-69.9885 245.291 256.41)",
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 252.129,
    y: 236.299,
    width: 10,
    height: 1.5,
    transform: "rotate(-74.891 252.129 236.299)",
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 257.256,
    y: 216.004,
    width: 10,
    height: 1.5,
    transform: "rotate(-78.0043 257.256 216.004)",
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 261.379,
    y: 195.549,
    width: 10,
    height: 1.5,
    transform: "rotate(-80.1062 261.379 195.549)",
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 264.805,
    y: 174.953,
    width: 10,
    height: 1.5,
    transform: "rotate(-81.7697 264.805 174.953)",
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 267.662,
    y: 154.223,
    width: 10,
    height: 1.5,
    transform: "rotate(-83.6822 267.662 154.223)",
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 269.299,
    y: 133.43,
    width: 10,
    height: 1.5,
    transform: "rotate(-86.4292 269.299 133.43)",
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 269.648,
    y: 112.729,
    width: 10,
    height: 1.5,
    transform: "rotate(-100.109 269.648 112.729)",
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 264.924,
    y: 92.5312,
    width: 10,
    height: 1.5,
    transform: "rotate(-112.225 264.924 92.5312)",
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 255.719,
    y: 73.9707,
    width: 10,
    height: 1.5,
    transform: "rotate(-127.007 255.719 73.9707)",
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 242.512,
    y: 57.9512,
    width: 10,
    height: 1.5,
    transform: "rotate(-133.779 242.512 57.9512)",
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 227.053,
    y: 43.9902,
    width: 10,
    height: 1.5,
    transform: "rotate(-147.892 227.053 43.9902)",
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 208.98,
    y: 33.7793,
    width: 10,
    height: 1.5,
    transform: "rotate(-156.889 208.98 33.7793)",
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 189.615,
    y: 26.2637,
    width: 10,
    height: 1.5,
    transform: "rotate(-164.157 189.615 26.2637)",
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 169.285,
    y: 21.3789,
    width: 10,
    height: 1.5,
    transform: "rotate(-170.524 169.285 21.3789)",
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 148.707,
    y: 18.3027,
    width: 10,
    height: 1.5,
    transform: "rotate(-175.528 148.707 18.3027)",
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 127.984,
    y: 17.4941,
    width: 10,
    height: 1.5,
    transform: "rotate(174.823 127.984 17.4941)",
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.498,
    y: 20.4805,
    width: 10,
    height: 1.5,
    transform: "rotate(163.557 107.498 20.4805)",
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 87.6562,
    y: 27.334,
    width: 10,
    height: 1.5,
    transform: "rotate(155.368 87.6562 27.334)",
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 69.043,
    y: 36.5156,
    width: 10,
    height: 1.5,
    transform: "rotate(146.684 69.043 36.5156)",
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.5312,
    y: 48.9141,
    width: 10,
    height: 1.5,
    transform: "rotate(132.861 52.5312 48.9141)",
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 39.4434,
    y: 64.9883,
    width: 10,
    height: 1.5,
    transform: "rotate(117.546 39.4434 64.9883)",
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 31.2754,
    y: 83.9707,
    width: 10,
    height: 1.5,
    transform: "rotate(102.514 31.2754 83.9707)",
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 27.6777,
    y: 104.512,
    width: 10,
    height: 1.5,
    transform: "rotate(91.0216 27.6777 104.512)",
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.3789,
    y: 125.039,
    width: 10,
    height: 1.5,
    transform: "rotate(70.5579 29.3789 125.039)",
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.1543,
    y: 144.152,
    width: 10,
    height: 1.5,
    transform: "rotate(66.1913 37.1543 144.152)",
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 45.4395,
    y: 163.588,
    width: 10,
    height: 1.5,
    transform: "rotate(61.3683 45.4395 163.588)",
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56.3223,
    y: 181.121,
    width: 10,
    height: 1.5,
    transform: "rotate(49.9015 56.3223 181.121)",
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 70.25,
    y: 196.506,
    width: 10,
    height: 1.5,
    transform: "rotate(43.8531 70.25 196.506)",
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 85.6367,
    y: 210.74,
    width: 10,
    height: 1.5,
    transform: "rotate(39.1148 85.6367 210.74)",
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 102.006,
    y: 223.377,
    width: 10,
    height: 1.5,
    transform: "rotate(33.419 102.006 223.377)",
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 119.646,
    y: 234.428,
    width: 10,
    height: 1.5,
    transform: "rotate(28.7459 119.646 234.428)",
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 138.373,
    y: 244.332,
    width: 10,
    height: 1.5,
    transform: "rotate(26.4883 138.373 244.332)",
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 157.125,
    y: 253.551,
    width: 10,
    height: 1.5,
    transform: "rotate(24.8526 157.125 253.551)",
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 175.914,
    y: 261.984,
    width: 10,
    height: 1.5,
    transform: "rotate(21.738 175.914 261.984)",
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 195.367,
    y: 269.361,
    width: 10,
    height: 1.5,
    transform: "rotate(17.9739 195.367 269.361)",
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 215.393,
    y: 275.527,
    width: 10,
    height: 1.5,
    transform: "rotate(15.0013 215.393 275.527)",
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 235.703,
    y: 280.914,
    width: 10,
    height: 1.5,
    transform: "rotate(14.9348 235.703 280.914)",
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 256.029,
    y: 286.178,
    width: 10,
    height: 1.5,
    transform: "rotate(11.486 256.029 286.178)",
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 276.246,
    y: 289.646,
    width: 10,
    height: 1.5,
    transform: "rotate(4.16483 276.246 289.646)",
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 297.361,
    y: 290.551,
    width: 10,
    height: 1.5,
    transform: "rotate(-2.66541 297.361 290.551)",
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 318.039,
    y: 288.795,
    width: 10,
    height: 1.5,
    transform: "rotate(-10.694 318.039 288.795)",
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 338.42,
    y: 284.486,
    width: 10,
    height: 1.5,
    transform: "rotate(-13.2868 338.42 284.486)",
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 358.572,
    y: 279.338,
    width: 10,
    height: 1.5,
    transform: "rotate(-20.0317 358.572 279.338)",
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 378.061,
    y: 271.432,
    width: 10,
    height: 1.5,
    transform: "rotate(-26.5991 378.061 271.432)",
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 396.367,
    y: 261.969,
    width: 10,
    height: 1.5,
    transform: "rotate(-27.5877 396.367 261.969)",
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 415.168,
    y: 252.416,
    width: 10,
    height: 1.5,
    transform: "rotate(-24.1997 415.168 252.416)",
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 434.473,
    y: 243.754,
    width: 10,
    height: 1.5,
    transform: "rotate(-24.8906 434.473 243.754)",
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 453.553,
    y: 235.115,
    width: 10,
    height: 1.5,
    transform: "rotate(-21.6245 453.553 235.115)",
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 473.145,
    y: 227.602,
    width: 10,
    height: 1.5,
    transform: "rotate(-21.3991 473.145 227.602)",
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 492.797,
    y: 220.68,
    width: 10,
    height: 1.5,
    transform: "rotate(-12.6743 492.797 220.68)",
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 513.5,
    y: 216.48,
    width: 10,
    height: 1.5,
    transform: "rotate(-6.06853 513.5 216.48)",
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 534.434,
    y: 215.279,
    width: 10,
    height: 1.5,
    transform: "rotate(5.27417 534.434 215.279)",
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 555.143,
    y: 218.193,
    width: 10,
    height: 1.5,
    transform: "rotate(14.2625 555.143 218.193)",
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 575.604,
    y: 224.344,
    width: 10,
    height: 1.5,
    transform: "rotate(24.893 575.604 224.344)",
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 594.277,
    y: 233.721,
    width: 10,
    height: 1.5,
    transform: "rotate(27.1954 594.277 233.721)",
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 613.125,
    y: 242.885,
    width: 10,
    height: 1.5,
    transform: "rotate(30.4427 613.125 242.885)",
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 630.355,
    y: 255.318,
    width: 10,
    height: 1.5,
    transform: "rotate(47.7459 630.355 255.318)",
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 640.647,
    y: 267.229,
    width: 5.31632,
    height: 1.5,
    transform: "rotate(48.5595 640.647 267.229)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-71-inside-1_413_3",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M76.0586 403.212C75.4415 401.621 75.3852 399.867 75.8991 398.24C76.413 396.613 77.4664 395.21 78.8853 394.262C80.3042 393.315 82.0038 392.879 83.7036 393.028C85.4034 393.176 87.0018 393.9 88.2348 395.079C89.4679 396.259 90.262 397.823 90.486 399.515C90.7099 401.206 90.3505 402.923 89.4668 404.383C88.5832 405.843 87.2283 406.957 85.6257 407.543C84.0232 408.129 82.2687 408.151 80.6521 407.605L81.7162 404.453C82.6157 404.757 83.5919 404.744 84.4835 404.419C85.3752 404.093 86.1291 403.472 86.6207 402.66C87.1124 401.848 87.3124 400.892 87.1878 399.951C87.0632 399.01 86.6213 398.14 85.9353 397.483C85.2492 396.827 84.3598 396.425 83.4141 396.342C82.4683 396.259 81.5226 396.502 80.7331 397.029C79.9436 397.556 79.3575 398.337 79.0716 399.242C78.7856 400.148 78.8169 401.123 79.1603 402.008L76.0586 403.212Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M76.0586 403.212C75.4415 401.621 75.3852 399.867 75.8991 398.24C76.413 396.613 77.4664 395.21 78.8853 394.262C80.3042 393.315 82.0038 392.879 83.7036 393.028C85.4034 393.176 87.0018 393.9 88.2348 395.079C89.4679 396.259 90.262 397.823 90.486 399.515C90.7099 401.206 90.3505 402.923 89.4668 404.383C88.5832 405.843 87.2283 406.957 85.6257 407.543C84.0232 408.129 82.2687 408.151 80.6521 407.605L81.7162 404.453C82.6157 404.757 83.5919 404.744 84.4835 404.419C85.3752 404.093 86.1291 403.472 86.6207 402.66C87.1124 401.848 87.3124 400.892 87.1878 399.951C87.0632 399.01 86.6213 398.14 85.9353 397.483C85.2492 396.827 84.3598 396.425 83.4141 396.342C82.4683 396.259 81.5226 396.502 80.7331 397.029C79.9436 397.556 79.3575 398.337 79.0716 399.242C78.7856 400.148 78.8169 401.123 79.1603 402.008L76.0586 403.212Z",
    stroke: "white",
    strokeWidth: 4.4599,
    mask: "url(#path-71-inside-1_413_3)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-72-inside-2_413_3",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M651.298 283.182C649.94 284.044 648.329 284.418 646.73 284.24C645.131 284.063 643.64 283.346 642.504 282.208C641.367 281.069 640.653 279.577 640.479 277.978C640.305 276.379 640.681 274.768 641.546 273.412C642.41 272.055 643.712 271.034 645.235 270.517C646.758 270 648.412 270.017 649.924 270.567C651.436 271.117 652.715 272.165 653.551 273.54C654.386 274.915 654.728 276.533 654.52 278.129L651.409 277.722C651.525 276.835 651.335 275.934 650.87 275.169C650.405 274.404 649.694 273.821 648.853 273.515C648.011 273.209 647.091 273.199 646.243 273.487C645.396 273.775 644.672 274.343 644.191 275.098C643.709 275.852 643.5 276.749 643.597 277.638C643.694 278.528 644.091 279.358 644.724 279.992C645.356 280.625 646.185 281.024 647.075 281.123C647.965 281.221 648.861 281.014 649.617 280.534L651.298 283.182Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M651.298 283.182C649.94 284.044 648.329 284.418 646.73 284.24C645.131 284.063 643.64 283.346 642.504 282.208C641.367 281.069 640.653 279.577 640.479 277.978C640.305 276.379 640.681 274.768 641.546 273.412C642.41 272.055 643.712 271.034 645.235 270.517C646.758 270 648.412 270.017 649.924 270.567C651.436 271.117 652.715 272.165 653.551 273.54C654.386 274.915 654.728 276.533 654.52 278.129L651.409 277.722C651.525 276.835 651.335 275.934 650.87 275.169C650.405 274.404 649.694 273.821 648.853 273.515C648.011 273.209 647.091 273.199 646.243 273.487C645.396 273.775 644.672 274.343 644.191 275.098C643.709 275.852 643.5 276.749 643.597 277.638C643.694 278.528 644.091 279.358 644.724 279.992C645.356 280.625 646.185 281.024 647.075 281.123C647.965 281.221 648.861 281.014 649.617 280.534L651.298 283.182Z",
    stroke: "white",
    strokeWidth: 4.16975,
    mask: "url(#path-72-inside-2_413_3)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_413_3",
    x: 16,
    y: 6,
    width: 648.58,
    height: 412,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_413_3"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_413_3",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSteps1);
export default __webpack_public_path__ + "static/media/steps_1.de3cc6b2054ec8a896b585c5bb973fe5.svg";
export { ForwardRef as ReactComponent };